import { GetEimpSource } from './GetEimpSource';
import { GetUntrustedSourceCount } from './GetUntrustedSourceCount';
import { ListEimpSources } from './ListEimpSources';
import { ListImpactedSystems } from './ListImpactedSystems';
import { ListSourceReportHistory } from './ListSourceReportHistory';
import { ListSources } from './ListSources';
import { ListTopContainmentSources } from './ListTopContainmentSources';

/**
 * queries
 *
 * @type {{ListTopContainmentSources: ((function({}=): Promise<*>)|*), GetEimpSource: ((function({}=): Promise<*>)|*),
 *     ListSources: ((function({}=): Promise<*>)|*), ListEimpSources: ((function({}=): Promise<*>)|*),
 *     ListSourceReportHistory: ((function({}=): Promise<*>)|*), GetUntrustedSourceCount: ((function({}=):
 *     Promise<*>)|*), ListImpactedSystems: ((function({}=): Promise<*>)|*)}}
 */
export const queries = {
  GetEimpSource,
  GetUntrustedSourceCount,
  ListEimpSources,
  ListImpactedSystems,
  ListSourceReportHistory,
  ListSources,
  ListTopContainmentSources,
};
